/**
 * useEthereumWallet hook.
 * Exported from a dedicated file to satisfy react-refresh/only-export-components —
 * hooks cannot live in the same file as the EthereumWalletProvider component.
 */

import { useContext } from 'react';

import { EthereumWalletContext } from './ethereumWalletContextDef';

export const useEthereumWallet = () => {
  const context = useContext(EthereumWalletContext);
  if (!context) {
    throw new Error('useEthereumWallet must be used within EthereumWalletProvider');
  }

  return context;
};
